import { Grid } from "@mui/material";
import React from "react";
import InputGroup from "../../../../../../../../components/Inputs/InputGroup";
import {
  dataDesign_designInputs,
  dataDesign_geometricParameters,
  dataDesign_heading1,
  dataDesign_heading2,
} from "./inputs";

export default function DesignDataPanel() {
  const [data, setData] = React.useState({});

  const onChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  return (
    <>
      <Grid container sx={{ pt: 2 }}>
        <Grid item xs={4}>
          <InputGroup name="Heading" inputs={dataDesign_heading1} />
        </Grid>
        <Grid item xs={4}>
          <InputGroup name="Heading" inputs={dataDesign_heading2} />
        </Grid>
      </Grid>
      <Grid container sx={{ pt: 2 }}>
        <Grid item xs={4}>
          <InputGroup
            name="Design Inputs"
            inputs={dataDesign_designInputs}
            keyAlign="right"
          />
        </Grid>
        <Grid item xs={4}>
          <InputGroup
            name="Geometric Parameters"
            inputs={dataDesign_geometricParameters}
          />
        </Grid>
      </Grid>
    </>
  );
}
